import React, { createContext } from "react";
import OrderArticle from "../models/order/OrderArticle.ts";

export const OrderArticleContext = createContext<{
  orderArticle?: OrderArticle;
  setOrderArticle?: React.Dispatch<React.SetStateAction<OrderArticle | null>>;
}>({ orderArticle: undefined, setOrderArticle: undefined });
